import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import type { DeleteAssetMutation } from '#/graphql/types';
import { deleteAsset } from '#/graphql/mutations';
import { GET_ASSET_PROPS_COUNTS } from './useAssetPropsCountsQuery';

const q = gql(deleteAsset);

const useAssetDelete = () => {
  const [mutation, result] = useMutation<DeleteAssetMutation>(q);
  const deleteAsset = useCallback(
    async (itemId: string) => {
      const response = await mutation({
        variables: {
          id: itemId,
        },
        refetchQueries: [{ query: GET_ASSET_PROPS_COUNTS }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.deleteAsset.data', undefined);
    },
    [mutation],
  );

  return { deleteAsset, result };
};

export default useAssetDelete;
